import { createFileRoute } from '@tanstack/react-router';

import { AccessControlEventsContainer } from '@/features/access-control-events/containers';

export const Route = createFileRoute('/_layout/access-control-events/')({
  component: AccessControlEventsContainer,
});
